import React from 'react'
import CardIcon from '~icons/solar/card-bold'
import PayPalLogo from '~icons/logos/paypal'
import StripeLogo from '~icons/simple-icons/stripe'
import BitcoinLogo from '~icons/logos/bitcoin'
import WiseLogo from '~icons/simple-icons/wise'

// The same brand icon set used in AddPaymentMethodModal's method picker,
// shared so every other place a payment method is displayed (payout
// tables/drawers, admin dashboard) renders the same icon for the same
// method instead of a generic card icon. logos/paypal and logos/bitcoin
// are already full-color brand marks; simple-icons/stripe and wise are
// single-color outlines that need their brand color applied explicitly.
export const PAYMENT_METHOD_ICONS: Record<string, React.ComponentType<{ className?: string; style?: React.CSSProperties }>> = {
  paypal: PayPalLogo,
  wise: WiseLogo,
  stripe: StripeLogo,
  crypto: BitcoinLogo,
}

export const PAYMENT_METHOD_ICON_COLORS: Record<string, string> = {
  wise: '#9FE870',
  stripe: '#635BFF',
}

export function getPaymentMethodIcon(method: string) {
  return PAYMENT_METHOD_ICONS[method] ?? CardIcon
}

export function getPaymentMethodIconColor(method: string): React.CSSProperties | undefined {
  const color = PAYMENT_METHOD_ICON_COLORS[method]
  return color ? { color } : undefined
}
